import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7367aa3b&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7367aa3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7367aa3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7367aa3b')) {
      api.createRecord('7367aa3b', component.options)
    } else {
      api.reload('7367aa3b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7367aa3b&scoped=true", function () {
      api.rerender('7367aa3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/abnormalOrders/anomaly/index.vue"
export default component.exports